import { URL } from '@sputnik/resources/constants'

const {
  DSA_TERMS_WEX_BO,
  DSA_TERMS_CRB_BO,
  DSA_TERMS_CRB_JS,
  DSA_TERMS_WEX_JS,
  DSA_TERMS_WEBBANK_BO,
  DSA_TERMS_WEBBANK_PG,
} = URL

export const mapAppSections = {
  authorizedSigner: 'AUTH_SIGNER',
  businessInfo: 'BUSINESS_INFO',
  companyOwners: 'COMPANY_OWNERS',
}

export const termsMapper = {
  major_account_change: {
    business_only: DSA_TERMS_WEX_BO,
    crb_business_only: DSA_TERMS_CRB_BO,
    crb_j_s: DSA_TERMS_CRB_JS,
    crb_mc_j_s: DSA_TERMS_CRB_JS,
    crb_mc_business_only: DSA_TERMS_CRB_BO,
    j_s: DSA_TERMS_WEX_JS,
    wex_business_only: DSA_TERMS_WEX_BO,
    wex_j_s: DSA_TERMS_WEX_JS,
    web_bank_pg: DSA_TERMS_WEBBANK_PG,
    web_bank_business_only: DSA_TERMS_WEBBANK_BO,
  },
  migration: {
    business_only: DSA_TERMS_CRB_BO,
    crb_business_only: DSA_TERMS_CRB_BO,
    crb_j_s: DSA_TERMS_CRB_JS,
    crb_mc_j_s: DSA_TERMS_CRB_JS,
    crb_mc_business_only: DSA_TERMS_CRB_BO,
    j_s: DSA_TERMS_CRB_JS,
    web_bank_pg: DSA_TERMS_WEBBANK_PG,
    web_bank_business_only: DSA_TERMS_WEBBANK_BO,
  },
  new: {
    business_only: DSA_TERMS_WEX_BO,
    crb_business_only: DSA_TERMS_CRB_BO,
    crb_j_s: DSA_TERMS_CRB_JS,
    crb_mc_j_s: DSA_TERMS_CRB_JS,
    crb_mc_business_only: DSA_TERMS_CRB_BO,
    j_s: DSA_TERMS_WEX_JS,
    wex_business_only: DSA_TERMS_WEX_BO,
    wex_j_s: DSA_TERMS_WEX_JS,
    web_bank_pg: DSA_TERMS_WEBBANK_PG,
    web_bank_business_only: DSA_TERMS_WEBBANK_BO,
  },
}

// add more types as they are needed
export const DSA_VERSION_TYPES = {
  CRB_B_O: 'crb_business_only',
  CRB_MC_B_O: 'crb_mc_business_only',
  CRB_MC_J_S: 'crb_mc_j_s',
  WEX_B_O: 'wex_business_only',
  WEB_BANK_PG: 'web_bank_pg',
  WEB_BANK_B_O: 'web_bank_business_only',
}
